import { LDateTime } from '@app/components/date/LDateTime';
import { ListViewChildProps } from '@app/core/list-view/ListView';
import { webApi } from '@mi-front/api-clients';
import { MrtTable } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { youtubeCuepointsMessages } from './messages/youtube-cuepoints-messages';

export type YoutubeCuepointsTableProps = ListViewChildProps<webApi.CuepointDto>;

/**
 * Paginated table for YouTube cuepoints (createdAt, videoId, id).
 */
export function YoutubeCuepointsTable(props: YoutubeCuepointsTableProps) {
  const { $t } = useIntl();
  const {
    data,
    total,
    pagination,
    onPaginationChange,
    isLoading = false,
    isFetching = false,
    showProgress = true,
  } = props;

  return (
    <Box>
      <MrtTable<webApi.CuepointDto>
        data={data}
        rowCount={total}
        state={{
          pagination,
          isLoading,
          showProgressBars: showProgress && (isLoading || isFetching),
        }}
        onPaginationChange={onPaginationChange}
        manualPagination
        enableColumnFilters={false}
        enableSorting={false}
        enableToolbarInternalActions={false}
        paginationDisplayMode="default"
        getRowId={(row) => row.id}
        columns={[
          {
            id: 'createdAt',
            header: $t(youtubeCuepointsMessages.columnCreatedAt),
            accessorFn: (row) => row.createdAt,
            Cell: ({ row: { original } }) => <LDateTime value={original.createdAt} showRelative />,
            size: 180,
          },
          {
            id: 'videoId',
            header: $t(youtubeCuepointsMessages.columnVideoId),
            accessorFn: (row) => row.videoId,
            Cell: ({ row: { original } }) => original.videoId,
            size: 280,
          },
          {
            id: 'id',
            header: $t(youtubeCuepointsMessages.columnCuepointId),
            accessorFn: (row) => row.youtubeResponse.id,
            Cell: ({ row: { original } }) => original.youtubeResponse.id,
            size: 320,
          },
        ]}
      />
    </Box>
  );
}
